import type { DiferencaComissao } from '../db/tipos'
import { arredondar2 } from '../pedidos/precos'
import { gravarLocalEEnfileirar } from '../sync/outbox'
import { converterNumeroBR } from '../lib/textoBR'
import { saldoDaDiferenca } from './conferencia'
import { rotuloMesCurto } from './painelDoMes'

// ▶ A diferenca do mes da fornecedora (spec 2026-10-05): quando o vendedor
// digita o TOTAL que a fabrica pagou, a diferenca para o calculado nao vai para
// pedido nenhum -- vira debito/credito do mes. Mesmo sinal do saldoPendente
// (> 0 credito, a fabrica deve a ele) e o mesmo par valor_acertado/acerto_em
// dos lancamentos, para o consumo na baixa e o "Pago" seguirem a mesma regra.

// O saldo mora em conferencia.ts (puro); reexportado aqui.
export { saldoDaDiferenca }

export function diferencasEmAberto(lista: DiferencaComissao[], representadaId: string): DiferencaComissao[] {
  return lista.filter((d) => d.representada_id === representadaId && saldoDaDiferenca(d) !== 0)
}

// Calculado menos pago. Sem pago, ou igual ate o centavo, nao ha diferenca.
export function diferencaDoTotalPago(calculado: number, pago: number | null): number {
  if (pago === null) return 0
  const d = arredondar2(calculado - pago)
  return Math.abs(d) < 0.005 ? 0 : d
}

// O "Pago" da aba Debitos/Creditos: acerta o saldo INTEIRO, por fora.
export async function acertarDiferenca(d: DiferencaComissao, dataISO: string): Promise<void> {
  const saldo = saldoDaDiferenca(d)
  if (saldo === 0) return
  await gravarLocalEEnfileirar('diferencas_comissao', {
    ...d, valor_acertado: arredondar2((d.valor_acertado ?? 0) + saldo), acerto_em: dataISO,
  })
}

// Revisao final 05/10: o que a janela do total pago guarda ao Salvar. Sem
// diferenca para o calculado (ou texto ilegivel), nao guarda nada -- senao
// abrir so para olhar fixava o "pago" e desmarcar uma linha depois criava uma
// divida que ela nunca digitou.
export function totalPagoParaGuardar(texto: string, calculado: number): string | null {
  const pago = converterNumeroBR(texto)
  if (pago === null || pago < 0) return null
  return diferencaDoTotalPago(calculado, pago) === 0 ? null : texto
}

export type LinhaDeDiferencaNoPdf = { id: string; descricao: string; situacao: 'Cobrar' | 'A devolver'; valor: number }

// Minor 04/10: o PDF da aba Debitos/Creditos somava as diferencas nos totais
// sem listar as linhas delas. Mesmo texto do cartao da tela; valor = saldo.
export function linhasDeDiferencaNoPdf(lista: DiferencaComissao[]): LinhaDeDiferencaNoPdf[] {
  const dataBR = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`
  return lista
    .filter((d) => saldoDaDiferenca(d) !== 0)
    .map((d) => {
      const saldo = saldoDaDiferenca(d)
      return {
        id: d.id,
        descricao: `Diferença do mês · ref. ${rotuloMesCurto(d.mes)} — do total pago na baixa de ${dataBR(d.data)}`,
        situacao: saldo > 0 ? 'Cobrar' : 'A devolver',
        valor: saldo,
      }
    })
}
